import { forwardRef } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { PhoneInputComponent, PhoneInputFieldWrapper, Error } from './PhoneInputField.styles';

const DEFAULT_PHONE_COUNTRY_PREFIX = 'US';

const PhoneInputComponentWithRef = forwardRef(({ error, ...props }, ref) => {
  return <PhoneInputComponent ref={ref} {...props} className={error ? 'error' : ''} />;
});

export const PhoneInputField = ({ value, onChange, onBlur, error }) => (
  <PhoneInputFieldWrapper>
    <PhoneInput
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder="Phone Number"
      error={error}
      inputComponent={PhoneInputComponentWithRef}
      international
      defaultCountry={DEFAULT_PHONE_COUNTRY_PREFIX}
    />
    {error && <Error>{error}</Error>}
  </PhoneInputFieldWrapper>
);
